import { Component } from '@angular/core';

@Component({
	selector: 'app-buttons',
	templateUrl: './buttons.component.html',
	styleUrls: ['./buttons.component.scss'],
	standalone: false,
})
export class ButtonsComponent {
	onButtonClick(buttonName: string): void {
		console.log(`Custom button clicked: ${buttonName}`);
	}
}
